import { lazy } from "react";

export const CreateReadingAsync = lazy(() => import("./CreateReading"));
